import { List } from 'immutable';
import type { Reducer } from 'redux';
import ErrorRecord from '~/data/ErrorRecord';
import UserManagementSubmenuRecord, {
  UserManagementSubmenuItem,
} from './data/UserManagementSubmenuRecord';
import type { UserManagementSubmenuActions } from './types/actions.types';
import UserManagementSubmenuConstants from './constants';

function getInitialState() {
  return new UserManagementSubmenuRecord();
}

const defaultState = getInitialState();

const reducer: Reducer<UserManagementSubmenuRecord, UserManagementSubmenuActions> = (
  state = defaultState,
  action
) => {
  switch (action.type) {
    case UserManagementSubmenuConstants.GET_USER_MANAGEMENT_SUBMENU_REQUEST:
      return state.merge({
        isLoading: true,
        error: undefined,
      });

    case UserManagementSubmenuConstants.GET_USER_MANAGEMENT_SUBMENU_REQUEST_SUCCESS: {
      const submenuItems = action.response.submenuItems;

      if (action.response.invitesSubmenuItem) {
        submenuItems.push({
          ...action.response.invitesSubmenuItem,
          icon: 'email-outlined',
        });
      }

      return state.merge({
        isLoading: false,
        hasLoaded: true,
        submenuItems: List<UserManagementSubmenuItem>(submenuItems),
      });
    }

    case UserManagementSubmenuConstants.GET_USER_MANAGEMENT_SUBMENU_REQUEST_ERROR:
      return state.merge({
        isLoading: false,
        hasLoaded: true,
        error: new ErrorRecord(action.error),
      });

    default:
      return state;
  }
};

export default reducer;
